/**
 * @ignore
 */
class BufferCloseTool {
    constructor(opts) {
        this.options = opts || {};
        //
        this.id = 'bufferCloseTool';
    }
    onMouseUp(button, shift, screenx, screeny, mapx, mapy, handled) {
        if (this.options.layer) {
            const graphic = this.options.layer.hitTest(screenx, screeny);
            if (graphic && graphic.element 
                && graphic.element.tag === 'closeButton') { // 关闭按钮
                    this.options.removeBuffer(this.options.bufferId);
                    this.options.callback && this.options.callback();
            }
        }
    }
}
module.exports = BufferCloseTool;